// Colunas que recebem total no topo: só as monetárias somáveis com o dado que já
// vem no payload. Contagem de contratos e média de dias ficam de fora até haver
// definição de produto.
const TOTALIZED_CONTRACT_COLUMNS = ['gross_value', 'monthly_premium', 'coverage_value']

const HIDDEN_COLUMN_CLASS = 'd-none'

/**
 * Normaliza os totais vindos do backend para exibição.
 *
 * Devolve `null` sem o bloco `column_totals` (resposta antiga ou busca que falhou),
 * para a linha de totais não ser desenhada com zeros inventados. Com o bloco, um
 * SUM() nulo vira 0, porque a soma de nada é zero.
 */
function buildContractColumnTotals(rawTotals) {
  if (!rawTotals) return null

  return TOTALIZED_CONTRACT_COLUMNS.reduce((totals, key) => {
    const value = Number(rawTotals[key])
    totals[key] = Number.isFinite(value) ? value : 0
    return totals
  }, {})
}

/**
 * Chave da primeira coluna visível, que ancora o rótulo "Totais". A personalização
 * esconde por classe, então essa coluna varia conforme a preferência do usuário.
 */
function firstVisibleContractColumnKey(columns) {
  const visible = (columns || []).find(column => column.thClass !== HIDDEN_COLUMN_CLASS)
  return visible ? visible.key : undefined
}

module.exports = {
  buildContractColumnTotals,
  firstVisibleContractColumnKey,
}
